import Reflux from 'reflux';
import UserData from 'shared/data/User';
import UserValidator from 'flux/validators/User';
import _ from 'underscore';

var async = { asyncResult: true },
  UserActions = Reflux.createActions({
    signup: async,
    signupWithTeam: async,
    loadFromSession: async,
    logout: async,
    update: async,
    updateField: async,
    updatePreference: async,
    updateOnboarding: async,
    updatePassword: async,
    updatePhoto: async,
    checkForExistingEmail: async,
    checkFor2FactorAuthSecret: async,
    setClientId: { sync: true },
  });

UserActions.loadFromSession.listenAndPromise(() => {
  return UserData.loadFromSession().then((user) => {
    return user;
  });
});

UserActions.checkForExistingEmail.listenAndPromise((email) => {
  return UserData.checkForExistingEmail(email);
});

UserActions.checkFor2FactorAuthSecret.listenAndPromise(
  UserData.has2FactorAuthSecret,
);

UserActions.logout.listenAndPromise(UserData.logout);

UserActions.signup.listenAndPromise((user, userPhoto) => {
  let scope = {};

  return UserData.signup(user)
    .then((createdUser) => {
      scope.createdUser = createdUser;
      return UserData.login(_.pick(user, 'email', 'password'));
    })
    .then((token) => {
      scope.token = token;

      if (!userPhoto) return scope;

      return UserData.updatePhoto(scope.createdUser._id, userPhoto).then(
        () => scope.createdUser,
      );
    })
    .then(() => scope.token);
});

UserActions.signupWithTeam.listenAndPromise(
  (user, team, teamPhoto, userPhoto) => {
    return UserData.signupWithTeam(user, team, teamPhoto, userPhoto).then(
      (ret) => ret,
    );
  },
);

UserActions.updateField.listenAndPromise(UserData.updateField);

UserActions.update.listenAndPromise(UserData.update);

UserActions.updatePreference.listenAndPromise(UserData.updatePreference);

UserActions.updateOnboarding.listenAndPromise(UserData.updateOnboarding);

UserActions.updatePhoto.listenAndPromise(UserData.updatePhoto);

UserActions.updatePassword.shouldEmit = (
  userId,
  currentPass,
  newPass,
  newPassConfirm,
) => {
  return UserValidator.confirmPassword(newPass, newPassConfirm);
};

UserActions.updatePassword.listenAndPromise(UserData.updatePassword);

export default UserActions;
